import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { HttpClientService } from '../../Services/http-client.service';
import { SessionService } from '../../Services/session.service';
import { UserService } from '../../Services/user.service';
import { AppSettings } from '../../app-settings';

declare var Stripe:any;

@Component({
  selector: 'app-payment-screen',
  templateUrl: './payment-screen.component.html',
  styleUrls: ['./payment-screen.component.css']
})
export class PaymentScreenComponent implements OnInit {
username:string="";
stripeBrandingURL:string = AppSettings.cdnUrl+'assets/images/stripe_branding.png';
usernameSubscription: Subscription;
stripePublicKey:string = AppSettings.stripePublicKey;
paymentIntentCS:string = '';
paymentFormValid:boolean = false;
newUserSubscription:boolean = false;
aboutToLogout:boolean = false;
paymentForm:any;
purchasedExtensionSubscription:Subscription;
paymentIntentKeySubscription:Subscription;
purchasedExtension:any;
validStringPattern:string="^[A-Za-z0-9.\\s ]+$";
validAddressPattern:string="^[A-Za-z0-9.,-/\\s ]+$";
Card:any;
disablePayBtn:boolean=false;
refreshSubscriptionURL:string = "https://e-gmattest.com/refresh-subscription/";
processStatus:string = "";
countries = [];

  constructor(private sessionService:SessionService, private userService: UserService, private formbuilder: FormBuilder, private httpClientService: HttpClientService){
    this.paymentForm = formbuilder.group({
      'nameOnCard': ['', [Validators.required,Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.validStringPattern)]],
      'address1': ['', [Validators.required,Validators.minLength(3), Validators.maxLength(100), Validators.pattern(this.validAddressPattern)]],
      'address2': ['', [Validators.maxLength(100), Validators.pattern(this.validAddressPattern)]],
      'country': ['IN', [Validators.required]]
    });
  }

  get nameOnCard() { return this.paymentForm.get('nameOnCard'); }
  get address1() { return this.paymentForm.get('address1'); }
  get address2() { return this.paymentForm.get('address2'); }
  get country() { return this.paymentForm.get('country'); }

  ngOnInit() {
    this.getPaymentIntentKey();
    this.getCountryList();
    this.getUsername();
    this.getPurchasedProduct();
    this.setupPaymentForm();
  }

  getCountryList()
  {
    this.httpClientService.get(AppSettings.restApiUrl+'/api/fetch-countries',new HttpHeaders()).subscribe((data)=>{
      if(data)
      {
          this.countries = data;
      }
    });
  }
  getPaymentIntentKey()
  {
      this.paymentIntentKeySubscription = this.sessionService.sharedPIKey.subscribe((data)=>{
        if(data)
        {
          this.paymentIntentCS = data;
        }
      });
  }

  getUsername()
  {
      this.usernameSubscription = this.sessionService.sharedAlternateUser.subscribe((data)=>{
        if(data)
        {
          this.username = data;
          this.newUserSubscription = true;
        }
        else{
          this.usernameSubscription = this.sessionService.getUserInfo$.subscribe((data)=>{
            if(data)
            {
              this.username = data.username;
            }
          });
        }
      });


  }

  getPurchasedProduct()
  {
    this.purchasedExtensionSubscription = this.sessionService.sharedPurchasedExtension.subscribe((data)=>{
      if(data)
      {
        this.purchasedExtension = data;
      }
    });
  }

  setupPaymentForm()
  {
    var then = this;
    var stripe = Stripe(this.stripePublicKey);
    var elements = stripe.elements();
    var style = {
      base: {
        fontSize:"16px",
        fontFamily:"lato",
        color: "#32325d",
      }
    };

    this.Card = elements.create("card", { style: style });
    this.Card.mount("#card-element");

    this.Card.on('change', ({error}) => {
      let displayError = document.getElementById('card-errors');
      if(then.processStatus!="")
      {
        then.processStatus = "";
        then.sessionService.sharePaymentResponse('');
      }
      if (error) {
        displayError.textContent = error.message;
        this.paymentFormValid = false;
      } else {
        displayError.textContent = '';
        this.paymentFormValid = true;
      }
    });

    var form = document.getElementById('payment-form');

    form.addEventListener('submit', function(ev) {
      ev.preventDefault();
      then.sessionService.sharePaymentResponse('');
      console.log(then.nameOnCard.value);
      console.log(then.Card);
      then.processStatus = "Processing your payment...";
      then.disablePayBtn = true;
      then.sendTransactionLog("BEFORE CONFIRM PAYMENT", null);
      stripe.confirmCardPayment(then.paymentIntentCS, {
        payment_method: {
          card: then.Card,
          billing_details: {
            name: then.nameOnCard.value,
            address:{
              country:then.country.value,
              line1:then.address1.value,
              line2:then.address2.value
            }
          }
        }
      }).then(function(result) {
        console.log("RESULT::::::::");
        console.log(result);
        then.sendTransactionLog("CONFIRMED PAYMENT",JSON.stringify(result));
        let paymentData = {};
        if (result.error) {
          // Show error to your customer (e.g., insufficient funds)
          // console.log(result.error.message);
          then.disablePayBtn = false;
          then.processStatus = "Payment was unsucessful";
          then.sessionService.sharePaymentResponse(result);
          paymentData['success'] = false;
          // if(result.error.hasOwnProperty('payment_intent'))
          // {
          //     paymentData['paymentId'] = result.error.payment_intent.id;
          // }
          // else
          // {
          //     paymentData['paymentId'] = '';
          // }
          // then.savePaymentData(paymentData,false);
        } else {
          then.disablePayBtn = false;
          // The payment has been processed!
          if (result.paymentIntent.status === 'succeeded')
          {
            // Show a success message to your customer
            // There's a risk of the customer closing the window before callback
            // execution. Set up a webhook or plugin to listen for the
            // payment_intent.succeeded event that handles any business critical
            // post-payment actions.
            then.processStatus = "Payment was successful";
            paymentData['success'] = true;
            paymentData['stripeStatus'] = result.paymentIntent.status;
            // paymentData['secretId'] = result.paymentIntent.client_secret;
            paymentData['paymentId'] = result.paymentIntent.id;

            then.savePaymentData(paymentData,true);
          }
          else
          {
            then.processStatus = "Payment was unsuccessful";
            paymentData['success'] = false;
            paymentData['paymentId'] = result.paymentIntent.id;
            paymentData['stripeStatus'] = result.paymentIntent.status;
            then.savePaymentData(paymentData,false);
          }
        }
      }).then(function(){then.sendTransactionLog("AFTER CONFIRM PAYMENT", null);});

    });
  }

sendTransactionLog(statusLog, resultLog){
  var statusLogObj = {}
  statusLogObj["statusLog"] = statusLog;
  statusLogObj["resultJson"] = resultLog;
  statusLogObj["username"] = this.username;
  this.httpClientService.post(AppSettings.restApiUrl + '/api/print-payment-status-log',statusLogObj,new HttpHeaders()).subscribe((data)=>{});
}

savePaymentData(paymentInfo,paymentSuccessFlag){
  let paymentStatus = paymentSuccessFlag?'successful':'unsuccessful';
  this.processStatus = "Saving Order Details...";
  paymentInfo['username'] = this.username;
  this.httpClientService.post(AppSettings.restApiUrl + '/api/save-payment-data',paymentInfo,new HttpHeaders()).subscribe((data)=>{
    if(data.success)
    {
      this.processStatus = "Saved Order Details Successfully, Refreshing your course subscription...";
      if(paymentInfo['success'])
      {

          if(this.newUserSubscription){
            this.processStatus = "";
            this.aboutToLogout = true;
            setTimeout(() =>{
                this.userService.logout();
            },10000);

          }
          else{
            window.location.href = data.redirectURL;
          }

      }
      else
      {
          this.processStatus = "Payment was " + paymentStatus + ", Please try again...";
      }
    }
    else
    {
        this.processStatus = "Payment was " + paymentStatus + ", Failed to save order status...";
    }
  });
}

  ngOnDestroy(){
    this.sessionService.sharePaymentResponse('');
    this.usernameSubscription.unsubscribe();
    this.purchasedExtensionSubscription.unsubscribe();
    this.paymentIntentKeySubscription.unsubscribe();
  }

}
